import * as React from 'react'
import { styled } from '@mui/material/styles'
import LinearProgress from '@mui/material/LinearProgress'

const DivComponent = styled('div')(({ theme }) => ({
  position: 'absolute',
}))

export const LoadingComponent: React.FC<{ isLoading: boolean }> = ({
  isLoading,
}) => {
  if (isLoading) {
    return (
      <DivComponent sx={{ width: '100%' }}>
        <LinearProgress color="success" />
      </DivComponent>
    )
  }
  return null
}
